import { MUSIC_EVENTS, VIDEO_EVENTS } from 'Sp/Angular/Events/Client/Gallery';

export default [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$location',
    'SPClientData',
    'SPClientRoute',
    'SPPhoto',
    'SPFavoritePhoto',
    'SPModal',
    'spClientCredentials',
    'spEventBus',
    'spEventTags',
    'spFreeDigitals',
    'spPackages',
    'spPhotoActions',
    function PhotoController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        SPClientData,
        SPClientRoute,
        SPPhoto,
        SPFavoritePhoto,
        SPModal,
        spClientCredentials,
        spEventBus,
        spEventTags,
        spFreeDigitals,
        spPackages,
        spPhotoActions
    ) {
        let untaggedPhoto = null;

        $scope.detailPhotoSize = null;

        $scope.closeLabelModal = closeLabelModal;
        $scope.closeAndGoToLabels = closeAndGoToLabels;
        $scope.isPackageItemSelected = isPackageItemSelected;
        $scope.isPackageSelected = isPackageSelected;

        $scope.navigateToPhoto = function navigateToPhoto(photo) {
            if (typeof photo !== 'object' || photo === $scope.detailPhoto) {
                return;
            }

            $scope.pauseDetailVideo();
            $scope.stopSlideshowPlayback();

            var newUri = $scope.getPhotoUri(photo);

            $scope.spLocalNavigation(newUri);
        };

        // The lightbox filmstrip keeps a window of nearby photos (including the currently playing
        // video) mounted for animation, so navigating to an adjacent photo does not by itself
        // unmount it — emit unconditionally so any video left mounted off-screen pauses instead of
        // continuing to play (and sound) in the background.
        $scope.pauseDetailVideo = function pauseDetailVideo() {
            spEventBus.emit(VIDEO_EVENTS.STOP);
        };

        // The lightbox filmstrip keeps a window of nearby photos (including the currently
        // playing slideshow) mounted for animation, so navigating to an adjacent photo does not
        // by itself unmount it — emit unconditionally so any slideshow left mounted off-screen
        // stops instead of continuing to play silently in the background.
        $scope.stopSlideshowPlayback = function stopSlideshowPlayback() {
            spEventBus.emit(MUSIC_EVENTS.STOP_SLIDESHOW);
        };

        $scope.kioskMode = false;

        $scope.enterKioskMode = function enterKioskMode() {
            if ($scope.kioskMode) {
                return;
            }

            $scope.kioskMode = true;
        };

        $scope.exitKioskMode = function exitKioskMode() {
            if (!$scope.kioskMode) {
                return;
            }

            $scope.kioskMode = false;
        };

        $scope.toggleKioskMode = function toggleKioskMode() {
            if (!$scope.kioskMode) {
                $scope.enterKioskMode();

                return;
            }

            $scope.exitKioskMode();
        };

        $scope.hasFiveOrMoreActions = function hasFiveOrMoreActions() {
            return (
                ($scope.photoActions.canHidePhoto() ? 1 : 0) +
                    ($scope.photoActions.canFavoritePhoto() ? 1 : 0) +
                    ($scope.photoActions.canBandWPhoto() ? 1 : 0) +
                    ($scope.photoActions.canTagPhoto() ? 1 : 0) +
                    ($scope.photoActions.canSharePhoto() ? 1 : 0) +
                    ($scope.photoActions.canDownloadPhoto() ? 1 : 0) >=
                5
            );
        };

        $scope.getSlideshowPlaceholderBg = function getSlideshowPlaceholderBg(photo) {
            var raw = photo.slideshowData && photo.slideshowData.backgroundColor;

            if (!raw) {
                return '#000000';
            }

            return (raw.charAt(0) === '#' ? raw : '#' + raw).toLowerCase();
        };

        $scope.disableKeyboardShortcuts = function disableKeyboardShortcuts() {
            return SPModal.isOpen() || $rootScope.isAddToCartSidePanelOpen;
        };

        $scope.photoActions = {};

        $scope.photoActions.canHidePhoto = function canHidePhoto() {
            return (
                !isPackageSelected() &&
                !$scope.kioskMode &&
                $scope.userState.isAdminModeEnabled &&
                $scope.eventData.settings.allowHiddenPhotos
            );
        };

        $scope.photoActions.togglePhotoHidden = function togglePhotoHidden(photo, onPhotoHidden) {
            if (!$scope.photoActions.canHidePhoto()) {
                return;
            }

            SPClientData.togglePhotoHidden(photo, onPhotoHidden);
        };

        $scope.photoActions.canFavoritePhoto = function canFavoritePhoto() {
            return !isPackageSelected() && SPPhoto.canFavoritePhoto();
        };

        $scope.photoActions.togglePhotoFavorite = function togglePhotoFavorite(
            photo,
            onPhotoFavorited
        ) {
            if (!$scope.photoActions.canFavoritePhoto()) {
                return;
            }

            if (SPClientRoute.getParentId() === 'Favorites' && photo.isFavorite) {
                removePhotoAndGoToNextPhoto(photo);
            }

            var email = spClientCredentials.get().email;

            /**
             * If user does not have an email set, and one was not passed here, we need to
             * present the modal to collect email address before setting it as a favorite.
             */
            if (!$scope.userState.hasUserEmail && !email) {
                return SPModal.open('favorite-get-email', {
                    partialDirectory: 'photo',
                    modalData: {
                        toggleFavorite: function toggleFavorite(email, doesAcceptTerms) {
                            SPClientData.togglePhotoFavorite(
                                photo,
                                email,
                                $scope.album,
                                doesAcceptTerms,
                                function onSuccess() {
                                    SPModal.close();

                                    if (typeof onPhotoFavorited === 'function') {
                                        onPhotoFavorited();
                                    }
                                },
                                function onError(response) {
                                    SPModal.getScope().errors = response.errors;
                                }
                            );
                        },
                        closeModal: function closeModal() {
                            SPModal.close();
                        }
                    }
                });
            }

            var favoriteOptions = {
                photo: photo,
                album: $scope.album,
                email: email,
                partialDirectory: 'photo'
            };

            SPFavoritePhoto.favoritePhoto(
                favoriteOptions,
                onPhotoFavorited,
                function favoritePhotoErrorCallback(errors) {
                    $scope.errors = errors;
                }
            );
        };

        $scope.photoActions.canBandWPhoto = function canBandWPhoto() {
            return (
                $scope.detailPhoto?.type !== 'slideshow' && $scope.eventData.settings.allowFiltering
            );
        };

        $scope.photoActions.togglePhotoBandW = function togglePhotoBandW(photo) {
            if (!$scope.photoActions.canBandWPhoto()) {
                return;
            }

            photo.filterBlackAndWhite = !photo.filterBlackAndWhite;
        };

        $scope.photoActions.canTagPhoto = function canTagPhoto() {
            return (
                !isPackageSelected() &&
                !$scope.kioskMode &&
                $scope.userState.isAdminModeEnabled &&
                $scope.eventData.settings.allowTagPhotos &&
                $scope.hasTags()
            );
        };

        $scope.getEventTag = getEventTag;

        $scope.canTogglePhotoTag = function canTogglePhotoTag(photo, tag) {
            var tagId = tag.id;
            var photoHasTagEnabled = photo.tags.indexOf(tagId) !== -1;
            var currentEventTag = spEventTags.eventTags[tagId];
            var photoAtMaximumCount =
                currentEventTag &&
                currentEventTag.maximumPhotoCount &&
                currentEventTag.photosCount >= currentEventTag.maximumPhotoCount;

            if (!photoHasTagEnabled && photoAtMaximumCount) {
                return false;
            }

            return true;
        };

        const spPhotoActionsHydrated = spPhotoActions($scope);

        $scope.photoActions.showTagModal = function showTagModal(photo, onTagSelected) {
            spPhotoActionsHydrated.showTagModal(photo, onTagSelected);
        };

        $scope.photoActions.setDownloadDestination = spPhotoActionsHydrated.setDownloadDestination;
        $scope.photoActions.getRemainingDownloads = spPhotoActionsHydrated.getRemainingDownloads;
        $scope.photoActions.cancelDownload = spPhotoActionsHydrated.cancelDownload;

        $scope.togglePhotoTag = function togglePhotoTag(photo, tag) {
            if (!$scope.photoActions.canTagPhoto() || typeof tag !== 'object') {
                return;
            }

            if (tag.name === $routeParams.tagName) {
                if (photo.tags.indexOf(tag.id) >= 0) {
                    untaggedPhoto = photo;
                } else {
                    untaggedPhoto = null;
                }
            }

            SPClientData.togglePhotoTag(photo, tag, function onTogglePhotoSuccess(data) {
                var eventTags = data.event_photo_tags;

                spEventTags.togglePhotoTagCount(eventTags);
            });
        };

        $scope.removeUntaggedPhotos = function removeUntaggedPhotos() {
            if (untaggedPhoto) {
                removePhotoAndGoToNextPhoto(untaggedPhoto);
            }
        };

        $scope.photoActions.canSharePhoto = function canSharePhoto() {
            return (
                $scope.detailPhoto?.type !== 'slideshow' &&
                !isPackageSelected() &&
                $scope.eventData.settings.allowSocialSharing
            );
        };

        $scope.photoActions.getPhotoShareUrls = SPClientData.getPhotoShareUrls;

        $scope.photoActions.canDownloadPhoto = function canDownloadPhoto() {
            return (
                $scope.detailPhoto?.type !== 'slideshow' &&
                !isPackageSelected() &&
                spFreeDigitals.canDownloadPhoto()
            );
        };

        $scope.photoActions.canDownloadVideo = function canDownloadVideo() {
            return (
                $scope.detailPhoto?.type !== 'slideshow' &&
                !isPackageSelected() &&
                spFreeDigitals.canDownloadVideo()
            );
        };

        $scope.photoActions.canDownloadSlideshow = function canDownloadSlideshow() {
            return !isPackageSelected() && spFreeDigitals.canDownloadSlideshow();
        };

        $scope.getDownloadTextHeaderKey = function getDownloadTextHeaderKey() {
            return 'downloadPhoto';
        };

        $scope.getDownloadTextProcessingKey = function getDownloadTextProcessingKey() {
            return 'downloadProcessing';
        };

        $scope.photoActions.downloadPhoto = function downloadPhoto(photo) {
            if (typeof photo !== 'object') {
                return;
            }

            // Videos are stored as photos with a video media type but must use the video
            // download flow so the video-specific digital rule settings are applied. A
            // video-only digital rule does not satisfy canDownloadPhoto, so videos must
            // gate on canDownloadVideo instead.
            if (photo.type === 'video') {
                if (!$scope.photoActions.canDownloadVideo()) {
                    return;
                }

                return spFreeDigitals.downloadVideo();
            }

            // Slideshows are also stored as photos with their own media type and their own
            // digital rule settings, so they gate on canDownloadSlideshow.
            if (photo.type === 'slideshow') {
                if (!$scope.photoActions.canDownloadSlideshow()) {
                    return;
                }

                return spFreeDigitals.downloadSlideshow();
            }

            if (!$scope.photoActions.canDownloadPhoto()) {
                return;
            }

            return spFreeDigitals.downloadPhoto();
        };

        $scope.photoActions.canAddPhotoToCart = function canAddPhotoToCart() {
            return spPhotoActionsHydrated.canAddPhotoToCart() && !$scope.isPackageSelected();
        };

        $scope.photoActions.addPhotoToCart = function addPhotoToCart(photo) {
            if (!$scope.photoActions.canAddPhotoToCart()) {
                return;
            }

            $rootScope.openAddToCartSidePanel({
                ...photo,
                url: $rootScope.SPPhoto.getUrl(photo, 'l'),
                editorUrl: $rootScope.SPPhoto.getUrl(photo, '2x')
            });
        };

        $scope.photoActions.canSelectForPackage = function canSelectForPackage() {
            return $scope.isPackageSelected() && $scope.isPackageItemSelected();
        };

        $scope.photoActions.selectForPackage = function selectForPackage(photo) {
            // Selling slideshows and videos isn't supported yet — exclude from package builder.
            if (photo.type === 'video' || photo.type === 'slideshow') {
                return;
            }

            spPackages.resetSelectedPackagePhotos();
            spPackages.togglePackagePhoto(photo, $scope.album);
        };

        $scope.detailPhotos = [];

        // Selling slideshows and videos isn't supported yet, so exclude them from the filmstrip
        // and the previous / next navigation while the package builder is open. Elsewhere the
        // full photo list is shown.
        $scope.$watchCollection('photos', updateDetailPhotos);
        $scope.$watch(isPackageSelected, updateDetailPhotos);

        $scope.$watch('photos', selectDetailPhoto);

        $scope.$on('SPLocalNavigationUpdate', selectDetailPhoto);

        initialize();

        function initialize() {
            if (window.getDevicePixelRatio() === 1) {
                if (window.isSmallDevice()) {
                    $scope.detailPhotoSize = 'm';
                } else if (window.isMediumDevice()) {
                    $scope.detailPhotoSize = 'l';
                } else {
                    $scope.detailPhotoSize = '2x';
                }
            } else {
                if (window.isSmallDevice()) {
                    $scope.detailPhotoSize = 'l';
                } else if (window.isMediumDevice()) {
                    $scope.detailPhotoSize = '2x';
                } else {
                    $scope.detailPhotoSize = '3x';
                }
            }

            spEventTags.getPhotoTags();
        }

        function getEventTag({ id }) {
            return spEventTags.eventTags[id];
        }

        function isPackageItemSelected() {
            return (
                Boolean(spPackages.getSelectedPackageItem().itemId) ||
                spPackages.isSinglePackageItemSelected()
            );
        }

        function isPackageSelected() {
            return Boolean(spPackages.getSelectedPackage());
        }

        function selectDetailPhoto() {
            if (typeof $scope.photos !== 'object') {
                return;
            }

            $scope.pauseDetailVideo();

            $scope.detailPhoto = $scope.getPhotoById($routeParams.photoId);

            // Redirect if detailPhoto cannot be resolved
            if (!$scope.detailPhoto) {
                if (typeof $scope.album === 'object') {
                    var parentUri = SPClientRoute.getParentUri($scope.album.parentAlbumId);

                    $location.url(parentUri);
                } else {
                    $location.url('home');
                }

                return;
            }

            $scope.setTargetPhoto($scope.detailPhoto);

            if (spPackages.getSelectedPackage()) {
                spPackages.selectPackagePhoto($scope.detailPhoto, $scope.album);
            }

            updateDetailPhotoNeighbors();

            if (
                $scope.passedProductSelectionState?.groupId &&
                $scope.photoActions.canAddPhotoToCart()
            ) {
                $scope.photoActions.addPhotoToCart($scope.passedProductSelectionState.foundPhoto);
            }
        }

        function updateDetailPhotos() {
            const photos = $scope.photos;

            if (!Array.isArray(photos)) {
                $scope.detailPhotos = photos;

                return;
            }

            $scope.detailPhotos = isPackageSelected()
                ? photos.filter((photo) => photo.type !== 'video' && photo.type !== 'slideshow')
                : photos;

            updateDetailPhotoNeighbors();
        }

        function updateDetailPhotoNeighbors() {
            const photos = Array.isArray($scope.detailPhotos) ? $scope.detailPhotos : [];
            const detailPhotoIndex = photos.indexOf($scope.detailPhoto);

            if (detailPhotoIndex === -1) {
                $scope.previousDetailPhoto = false;
                $scope.nextDetailPhoto = false;

                return;
            }

            $scope.previousDetailPhoto = photos[detailPhotoIndex - 1] || false;
            $scope.nextDetailPhoto = photos[detailPhotoIndex + 1] || false;
        }

        function removePhotoAndGoToNextPhoto(photo) {
            $scope.photos.splice($scope.photos.indexOf(photo), 1);

            if ($scope.photos.length >= 1) {
                $scope.navigateToPhoto($scope.nextDetailPhoto || $scope.photos[0]);
            } else {
                $location.url(SPClientRoute.getParentUri());
            }
        }

        function closeLabelModal() {
            SPModal.close();
        }

        function closeAndGoToLabels() {
            SPModal.close();
            $location.path('labels');
        }
    }
];
